import React from 'react';
import { Col, Row, Visible } from 'react-grid-system';
import Icon from '@Components/Icon/Icon';
import DesktopIcon from './DesktopIcon';
import { ICON_SIZE } from '../ShippingMethod';
import {
	HeaderWrapper,
	IconWrapper,
	ShippingWrapper,
} from '@Components/Card/cards/TermsAndConditions/TermsAndConditions.styled';
import { DescriptionWrapper, TitleWrapper } from '../ShippingMethod.styled';

interface IPageContent {
	children?: JSX.Element;
	description: string;
	name: types.iconNames;
	title: string;
	withoutChild?: boolean;
}

const ContentBody = ({ description, name, title }: Omit<IPageContent, 'children'>): JSX.Element => (
	<HeaderWrapper>
		<Visible xs>
			<IconWrapper>
				<Icon testID={`mobile-${name}`} name={name} fill="black38" width={ICON_SIZE} height={ICON_SIZE} />
			</IconWrapper>
		</Visible>
		<div>
			<TitleWrapper>{title}</TitleWrapper>
			<DescriptionWrapper>{description}</DescriptionWrapper>
		</div>
	</HeaderWrapper>
);

const PageContent = ({ children, description, name, title, withoutChild = false }: IPageContent): JSX.Element => (
	<Row>
		<DesktopIcon name={name} />
		<Col lg={11} md={11} sm={11}>
			{withoutChild ? (
				<ContentBody description={description} name={name} title={title} />
			) : (
				<ShippingWrapper>
					<Row>
						<ContentBody description={description} name={name} title={title} />
					</Row>
					{children}
				</ShippingWrapper>
			)}
		</Col>
	</Row>
);

export default PageContent;
